import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.min.css';
import Img from 'gatsby-image';

SwiperCore.use([Navigation, Pagination, Autoplay]);

const ImageGallery = ({ slides }) => (
  <div style={{ marginBottom: 'calc(var(--v-spacing-L) * 2)' }}>
    <StyledCarousel
      loop
      freeMode="true"
      slidesPerView="auto"
      grabCursor="false"
      spaceBetween={12}
      pagination={{
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      }}
      navigation={{
        nextEl: '.next',
        prevEl: '.prev',
      }}
      className="spacing-side-removed"
    >
      {slides.map((slide, i) => (
        <SwiperSlide key={i}>
          <figure className="img-container">
            <Img
              className={slide.portrait ? 'portrait-img' : 'img'}
              fluid={slide.image.asset.fluid}
              alt={slide.alt}
            />
          </figure>
        </SwiperSlide>
      ))}
    </StyledCarousel>
    <StyledControls className="controls">
      <button type="button" className="prev">
        ←
      </button>
      <div className="swiper-pagination" />
      <button type="button" className="next">
        →
      </button>
    </StyledControls>
  </div>
);

const StyledCarousel = styled(Swiper)`
  position: relative;

  .img {
    width: 80vh;
    height: 60vh;
  }

  .portrait-img {
    width: 45vh;
    height: 60vh;
  }

  .swiper-wrapper {
    padding-left: var(--v-spacing-S);
  }

  .swiper-slide {
    width: auto !important;
  }

  .swiper-button-next,
  .swiper-button-prev {
    &::after {
      font-family: var(--font-1);
      font-size: var(--font-size-1);
      font-weight: 300;
      color: var(--blue);
    }
  }

  .swiper-button-next {
    &::after {
      content: '→';
    }
  }

  .swiper-button-prev {
    &::after {
      content: '←';
    }
  }
`;

const StyledControls = styled.div`
  padding-top: var(--spacing-XXS);
  position: absolute;
  display: flex;

  .prev,
  .next {
    color: var(--blue);
  }

  .prev {
    margin-right: var(--spacing-XXS);
  }

  .next {
    margin-left: var(--spacing-XXS);
  }

  .swiper-pagination {
    position: static;
    display: flex;
    align-items: center;

    .swiper-pagination-bullet {
      height: 6px;
      width: 6px;
      opacity: 1;
      background: #d8d8d8;
      margin: 0 var(--spacing-XXS);
    }

    .swiper-pagination-bullet-active {
      background: var(--red);
    }
  }
`;

ImageGallery.propTypes = {
  slides: PropTypes.array.isRequired,
};

export default ImageGallery;
